import React, { useState } from "react";
import { SelectChangeEvent } from "@mui/material";
import {
  postToggle,
  postToggleMarkup,
  postHideCustomer,
  postSeriesOverride,
} from "../../../api/OrderSummaryApi";
import { SetStateBool, SetStateString } from "./Settings";

function useSettingsSelector(
  marginInput: string,
  fixedMargin: string,
  fixedMarkup: string,
  setMarginInput: SetStateString,
  setOverride: SetStateBool,
  setHideCustomer: SetStateString,
  quoteId: string,
  markupChecked: boolean,
  setSeries: SetStateString,
  resetPDF: () => void
) {
  const role = JSON.parse(sessionStorage.getItem("role") || JSON.stringify(""));

  const [anchorEl, setAnchorEl] = useState(null);

  const open = Boolean(anchorEl);

  const handleClick = (event: React.ChangeEvent<any>) => {
    setAnchorEl(event.currentTarget);
  };

  const handleClose = () => {
    setAnchorEl(null);
  };

  const handleToggle = async (event: React.ChangeEvent<HTMLInputElement>) => {
    const { checked } = event.target;
    setOverride(checked);

    if (markupChecked) {
      if (!checked && fixedMarkup && marginInput !== fixedMarkup) {
        setMarginInput(fixedMarkup);
        resetPDF()
      }
      await postToggleMarkup(checked, quoteId);
    } else {
      if (!checked && fixedMargin && marginInput !== fixedMargin) {
        setMarginInput(fixedMargin);
        resetPDF()
      }
      await postToggle(checked, quoteId);
    }
  };

  const handleChange = async (event: SelectChangeEvent<string>) => {
    const { value } = event.target;
    setHideCustomer(value);

    const dbValue = value === "Show All" ? "" : value;
    await postHideCustomer(dbValue, quoteId);
    resetPDF()
  };

  const handleChangeSeries = async (event: SelectChangeEvent<string>) => {
    const { value } = event.target;
    setSeries(value);

    await postSeriesOverride(value, quoteId);
    resetPDF()
  };

  const switchText =
    fixedMargin && !markupChecked
      ? "Margin"
      : fixedMarkup && markupChecked
      ? "Markup"
      : "Margin";

  return {
    switchText,
    handleChangeSeries,
    handleChange,
    handleToggle,
    handleClick,
    open,
    anchorEl,
    handleClose,
    role,
  };
}

export default useSettingsSelector;
